import React from 'react';
import { translate } from '../../../../../../../Services/translation';
import { setWithAssembly } from '../../../../../../../Actions/Checkout.action';
import { useDispatch } from 'react-redux';

const CheckoutPaymentFormAssembly = ({ checkout }) => {
  const { payload } = checkout || {};
  const { isBusinessCustomer, isAssemblyAllowed, withAssembly } = payload || {};

  const dispatch = useDispatch();
  const handleSetWithAssembly = (value) => dispatch(setWithAssembly(value));

  if (isBusinessCustomer || !isAssemblyAllowed) {
    return null;
  }

  return (
    <div className="mb-8 last:mb-0">
      <label htmlFor="withAssembly" className="inline-flex items-start gap-2">
        <input
          id="withAssembly"
          className="mt-1"
          type="checkbox"
          checked={withAssembly}
          onChange={() => handleSetWithAssembly(!withAssembly)}
        />
        <span>{translate('checkout.withassembly')}</span>
      </label>
    </div>
  );
};

export default CheckoutPaymentFormAssembly;
